<template>
    <div class="pa-5 compact-form">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Client name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.name"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'name')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col cols="6">
                <v-autocomplete
                    v-model="country"
                    :items="countries"
                    :loading="isLoading"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    hide-no-data
                    hide-selected
                    :item-text="
                        item =>
                            (item.name_et ? item.name_et : null) +
                            (item.name_en ? item.name_en : null) +
                            ' (' +
                            item.code +
                            ')'
                    "
                    item-value="code"
                    outlined
                    :placeholder="t('Start typing to Search')"
                    return-object
                >
                    <template slot="selection" slot-scope="{ item, selected }">
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                    <template slot="item" slot-scope="{ item, tile }">
                        <country-flag :country="item.code" size="small" class="mr-1" />
                        {{ item.name_et ? item.name_et : item.name_en }} ({{ item.code }})
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col :cols="1">
                <country-flag v-if="country && country.code" :country="country.code" class="mt-0 ml-1" size="normal" />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Region" | t }}</v-col>
            <v-col cols="6">
                <v-select
                    :items="regions"
                    :value="activeClient.region"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    item-text="title"
                    item-value="id"
                    outlined
                    placeholder="Select"
                    @input="updateField($event, 'region')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Address" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.address"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'address')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Latitude" | t }}/{{ "Longitude" | t }}</v-col>
            <v-col cols="3">
                <v-text-field
                    :value="activeClient.latitude"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    type="number"
                    @input="updateField($event, 'latitude')"
                />
            </v-col>
            <v-col cols="3">
                <v-text-field
                    :value="activeClient.longitude"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    type="number"
                    @input="updateField($event, 'longitude')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Manager" | t }}</v-col>
            <v-col cols="6">
                <v-autocomplete
                    v-model="manager"
                    :items="users"
                    :loading="isLoading"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    hide-no-data
                    hide-selected
                    item-text="name"
                    item-value="id"
                    label=""
                    outlined
                    :placeholder="t('Start typing to Search')"
                    return-object
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Total profit" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.total_profit"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    type="number"
                    @input="updateField($event, 'total_profit')"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Met place" | t }}</v-col>
            <v-col cols="6">
                <v-combobox
                    v-model="met_place"
                    :items="metPlaces"
                    :loading="isLoading"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    hide-no-data
                    hide-selected
                    item-text="name"
                    item-value="id"
                    label=""
                    outlined
                    :placeholder="t('Start typing to Search')"
                ></v-combobox>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Met date" | t }}</v-col>
            <v-col class="mb-1" cols="6">
                <date-picker v-model="metDate" :popover="{ placement: 'bottom', visibility: 'click' }" />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Comment" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeClient.comment"
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                    @input="updateField($event, 'comment')"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import Store from "@/store";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import CountryFlag from "vue-country-flag";

export default {
    name: "client-info-edit-tab",
    components: {
        DatePicker,
        CountryFlag
    },
    data() {
        return {
            regions: ["-", "europe", "norhern usa", "southern usa", "asia", "oceanian", "africa", "middle east"],
            metDate: "",
            isLoading: false,
            manager: null,
            met_place: null,
            country: null
        };
    },

    async mounted() {
        setTimeout(async () => {
            if (this.users.length <= 0) {
                await this.getFrequentlyUsedQueries({ users: true });
            }
            if (this.activeClient.met_date) {
                this.metDate = moment(this.activeClient.met_date, "DD.MM.YYYY").toDate();
            }
            if (this.activeClient.region === "none") this.updateField("-", "region");
            this.manager = this.users.find(x => x.id === this.activeClient.manager_id);
            await Store.dispatch("ExportClientStore/getAllMetPlaces").then(() => {
                this.met_place = this.metPlaces.find(x => x.id === this.activeClient.met_place_id);
            });
            await Store.dispatch("fetchCountries");
            if (this.activeClient.country_code) {
                this.country = this.countries.find(x => x.code === this.activeClient.country_code);
            }
        }, 200);
    },
    watch: {
        metDate: function(value) {
            this.updateField(moment(value).format("DD.MM.YYYY"), "met_date");
        },
        manager: function(value) {
            if (value && value.id) this.updateField(value.id, "manager_id");
        },
        met_place: function(value) {
            if (value && value.name) this.updateField(value.name, "met_place_name");
            else this.updateField(value, "met_place_name");
        },
        country: function(value) {
            value && value.code ? this.updateField(value.code, "country") : this.updateField(null, "country");
        }
    },
    methods: {
        ...mapActions(["getFrequentlyUsedQueries"]),
        updateField(value, field) {
            Store.commit("ExportClientStore/updateActiveClientProperty", { prop: field, value: value });
        }
    },
    computed: {
        ...mapState(["countries", "users"]),
        ...mapState("ExportClientStore", ["activeClient", "metPlaces"])
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
